import { get } from 'lodash/object';
import { create$Http } from '@x-tech/fe-puma-lib-http/dist/puma';
import { createAxiosInstance } from '@x-tech/fe-puma-lib-http';
import * as authHelper from '../helper/auth';
import store from '../store/store';

// const SUCCESS = '000'; // 操作成功
// const FAILED = '001'; // 操作失败
// const PARAM_INVALID = '002'; // 参数错误
// const ROLE_NOT_FOUND = '003'; // 角色不存在
// const PRODUCT_NOT_FOUND = '004'; // 产品不存在
// const ROLE_DUPLICATION = '005'; // 角色名称或编码重复
// const ROLE_PARENT_INVALID = '006'; // 父角色非法
// const XML_META_INVALID = '007'; // 权限配置文件校验不通过
// const TIME_RANGE_ILLEGAL = '008'; // 时间范围非法
// const OPERATION_ILLEGAL = '009'; // 非法操作
// const REQUEST_METHOD_NOT_SUPPORT = '010'; // 请求方式错误
// const SYSTEM_ERROR = '100'; // 系统错误
// const APPLICATION_ERROR = '101'; // 程序异常
// const BUSINESS_ERROR = '102'; // 业务异常
// const DB_ERROR = '103'; // 数据异常
// const VERIFICATION_FAILED = '080'; // 验证码错误
// const PASSWORD_FAILED = '081'; // 用户不存在或密码错误
// const USER_DELETED = '081'; // 用户已删除
// const USER_DISABLED = '081'; // 用户已冻结
// const USER_LEAVE = '081'; // 用户已离职
// const EXIST = '083'; // 操作失败，记录已存在
// const NO_EXIST = '084'; // 用户不存在
// const LOG_TOKEN_INVALID = '085'; // 日志KEY无效
// const UV_COLLECT_FAILED = '086'; // 该元素不在统计范围内);
const NO_LOGIN = '082'; // 未登录或登录已失效

let $http = create$Http({
    baseURL: window.XCConfig.VUE_APP_URL,
});

$http.interceptors.response.use(
    res => res,
    err => {
        let res = err.response;
        if (res) {
            let statusCode = res.status;
            if (statusCode === 401) {
                authHelper.handleLogout();
                return;
            } else if (statusCode === 403) {
                let method = get(res, 'data.data.method', '');
                if (method === 'SMS') {
                    store.dispatch('setIsNeedSecondAuth', true);
                } else {
                    return Promise.reject(err);
                }
            } else {
                return Promise.reject(err);
            }
        } else {
            let code = err.code;
            if (typeof code !== 'undefined') {
                if (code === NO_LOGIN) {
                    authHelper.handleLogout();
                    return;
                }
                return Promise.reject(err);

            }
            return Promise.reject(err);
        }
    },
);

// 发生错误的时候 不会默认弹出 message
const simple$http = createAxiosInstance({
    config: {
        baseURL: window.XCConfig.VUE_APP_URL,
    },
});

function receivePageInfo(params = {}) {
    return simple$http.post('/pes/skywalking/receivePageInfo', params);
}

function logCollect(productCode = '', elementCode = '') {
    return $http.put('/xlog/uv/collect', {
        productCode,
        elementCode,
    });
}

// 记录消息跳转
export function msgClick(params = {}) {
    return $http.get(`/mes/entrance/msg/click?messageEncryptId=${params.id}`);
}

export {
    $http,
    simple$http,
    receivePageInfo,
    logCollect
};
